import sessionStates from 'constants/session.js';

const initialState = {
  authUser: null,
  currentOrgId: null,
  selectedProduct: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case sessionStates.AUTH_USER_SET_OR_UPDATE:
      return { ...state, authUser: payload };
    case sessionStates.ORG_ID_SET_OR_UPDATE:
      return { ...state, currentOrgId: payload };
    case sessionStates.SELECTED_PRODUCT_SET_OR_UPDATE:
      return { ...state, selectedProduct: payload };
    case sessionStates.USER_ACCESS_SET_OR_UPDATE:
      return { ...state, userAccess: payload };
    default:
      return state;
  }
};
